// Три чипа: Критический / Обычный / Низкий.
// Critical доступен только для account/service_down
// (см. PLAN.md и бэкенд /kubikon3d/tickets create).
// «subscription» убрана 2026-05-25 — подписка отдельная тема Майнкрафтии.
import React from "react";

const CRITICAL_ALLOWED = new Set(["account", "service_down"]);

const PRIORITIES = [
  { id: "critical", label: "Критический", cls: "sup-pri-chip--critical" },
  { id: "normal",   label: "Обычный",     cls: "sup-pri-chip--normal" },
  { id: "low",      label: "Низкий",      cls: "sup-pri-chip--low" },
];

export default function TicketPrioritySelect({ value, onChange, category }) {
  const criticalDisabled = !CRITICAL_ALLOWED.has(category);

  return (
    <div className="sup-pri-row">
      {PRIORITIES.map((p) => {
        const isCritical = p.id === "critical";
        const disabled = isCritical && criticalDisabled;
        const active = value === p.id && !disabled;
        return (
          <button
            key={p.id}
            type="button"
            disabled={disabled}
            title={
              disabled
                ? "Критический доступен для подписки, аккаунта и сервиса"
                : undefined
            }
            className={`sup-pri-chip ${p.cls} ${active ? "is-active" : ""}`}
            onClick={() => onChange(p.id)}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
